import { createReducer } from '@reduxjs/toolkit';
import type { UIState } from './state';
import initialUIState from './state';
import { setUIState } from './actions';

export const uiReducer = createReducer<UIState>(initialUIState, (builder) => {
  builder.addCase(setUIState, (state, { payload }) => payload);
});
